module.exports = __webpack_public_path__ + "img/img-video-escritorio.6b921f73.png";